import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    FreightForwarder,
} from 'app/Apps/OrderManagement/FreightForwarders/FreightForwarders.types'
import config from 'app/requests/FreightForwarder.request'

const useGetFreightForwarder = (id) => {
    return useRequest<FreightForwarder>({
        key: RequestKeys.getFreightForwarder,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetFreightForwarder
